import { render, staticRenderFns } from "./UnsyncedMessagePageTable.vue?vue&type=template&id=be137732"
import script from "./UnsyncedMessagePageTable.vue?vue&type=script&lang=js"
export * from "./UnsyncedMessagePageTable.vue?vue&type=script&lang=js"
import style0 from "./UnsyncedMessagePageTable.vue?vue&type=style&index=0&id=be137732&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports